import React from 'react';
import { useParams, Link } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { getFamilyDashboardSectionById } from '../config/familyDashboard';
import ComingSoon from '../shared/ComingSoon';

export default function FamilyDashboardDetail() {
  const { id } = useParams();
  const section = getFamilyDashboardSectionById(id);

  return (
    <div className="page">
      <Link to="/family-dashboard" className="back-link">
        <ArrowBackIcon fontSize="small" /> Back to Family Dashboard
      </Link>
      {section ? (
        <ComingSoon
          title={section.title}
          description="This Family Dashboard section is planned but not yet available. It will be built out in a future step."
        />
      ) : (
        <ComingSoon title="Unknown section" description="This Family Dashboard section does not exist." />
      )}
    </div>
  );
}
